const API_URL = process.env.REACT_APP_API_URL || 'https://bio-world.eu/api';

export default API_URL;
